var $ = jQuery.noConflict();
$(document).ready(function($){

//PRELOADER ON LOAD
//	$(".se-pre-con").fadeOut(300);

//SLICK SLIDER INITIALIZE  
  $('.hb__slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		speed: 1000,
		autoplay: true,
		fade: false,
		dots: false,
		arrow: false,
		autoplaySpeed: 7000,
		pauseOnHover: false,
		
	});
  
  $('.testimonial-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: true,
		speed: 1000,
		autoplay: false,
		fade: false,
		dots: false,
		arrow: false,
		autoplaySpeed: 5000,
        responsive:[
          { 
            breakpoint: 921,
		  		settings: {
					slidesToShow: 2,	
					slidesToScroll: 1
		  		}
          },
          {
            breakpoint: 569,
		  		settings: {
					slidesToShow: 1,	
					slidesToScroll: 1
		  		}
          }
        ]
	});

//ACCORDION
$('.add-accordion').each(function(){
	var those = $(this);
	var $first_div = '#' + $(this).find('.accordion-container:first').find('.accordion').attr('id');
	var $question_div = '#' + $(this).find('.accordion-container:first').find('.accordion-question-container').attr('id');
	var $answer_div = '#' + $(this).find('.accordion-container:first').find('.accordion-answer-container').attr('id');
	var $btn_icon = '#' + $(this).find('.accordion-container:first').find('.accordion-button-icon').attr('id');
	var $content_div = $(this).find('.accordion-container:first').addClass('accordion-container-active');

	$('.tb-mobile-tab' + $first_div).addClass('accordion-active');
	$('.tb-mobile-tab' + $question_div).addClass('question_active');
	$('.tb-mobile-tab' + $answer_div).addClass('answer_active').slideDown(300);
	$('.tb-mobile-tab' + $btn_icon).text('-');
	$('.tb-mobile-tab' + $btn_icon).removeClass('xdclose').addClass('xdopen');
	
	those.find('.accordion-question-container').click(function(){
		var that = $(this);
		if( $(this).next().css('display') == 'none' ){
			those.find('.accordion').removeClass('accordion-active');
			those.find('.accordion-container').removeClass('accordion-container-active');
			those.find('.accordion-question-container').removeClass('question-active');
			those.find('.accordion-answer-container').removeClass('answer-active');
			those.find('.accordion-button-icon').text('+');
		//	those.find('.accordion-button-icon').removeClass('xdclose').addClass('xdopen');
			those.find('.accordion-answer-container').slideUp(300);
			
			that.parent().addClass('accordion-active');
			that.parent().parent().addClass('accordion-container-active');
			that.addClass('question-active');
			that.next().addClass('answer-active');
			that.next().slideDown(300);
			that.find('.accordion-button-icon').text('-');
		//	that.find('.accordion-button-icon').removeClass('xdopen').addClass('xdclose');
		} else {
			those.find('.accordion').removeClass('accordion-active');
			those.find('.accordion-container').removeClass('accordion-container-active');
			those.find('.accordion-question_container').removeClass('question-active');
			those.find('.accordion-answer_container').removeClass('answer-active');
			those.find('.accordion-button-icon').text('+');
		//	those.find('.accordion-button-icon').removeClass('xdclose').addClass('xdopen');
			those.find('.accordion-answer-container').slideUp(300);
		}
	});
});

//SMOOTH SCROLL
$('.desc-readmore').click(function(e) {
  e.preventDefault();
  $("html, body").animate({ 
  	scrollTop: $("#product-description-1").offset().top 
	}, "slow");
  return false;
});

$('.smooth-scroll').click(function(e) {
  e.preventDefault();
  $("html, body").animate({ 
  	scrollTop: $("#judgeme_product_reviews").offset().top 
	}, "slow");
  return false;
});


//ADD > TO FORM
  $('.button--primary').attr("value", "Submit");
  
//ANIMATE OBJECT ON MOUSE MOVE
$(".home-banner").mousemove(function(e) {
  parallaxIt(e, ".hb-background", -30);
});

$('.features-items').each(function(){
  $(this).mousemove(function(e) {
    var b = $(this).find('.features-img');
    parallaxIt(e, b, -20);
  });
})

  

function parallaxIt(e, target, movement) {
  var $this = $(".home-banner");
  var relX = e.pageX - $this.offset().left;
  var relY = e.pageY - $this.offset().top;

  TweenMax.to(target, 1, {
    x: (relX - $this.width() / 2) / $this.width() * movement,
    y: (relY - $this.height() / 2) / $this.height() * movement
  });
}

//ADD ANIMATION TO COLLECTION
$('.home-row-3 .product:nth-child(1)').addClass('left');
$('.home-row-3 .product:nth-child(2), .home-row-6 .halo-block-header').addClass('top');
$('.home-row-3 .product:nth-child(3), .home-row-6 .halo-product-block').addClass('bottom');

 
//GSAP SCRIPTS
gsap.registerPlugin(ScrollTrigger);
//ANIMATION FROM GSAP
ScrollTrigger.batch(".tofasdfp", {
	onEnter: batch => gsap.from(batch, {
		start : "top center",
		duration: 1, 
		y: -100,
		autoAlpha : 0,
		toggleAction : "restart reset restart reset"			
	}),
});

	
ScrollTrigger.batch(".top", {
	onEnter: batch => gsap.from(batch, {
		duration: 1, 
		y: -100,
		autoAlpha : 0,
	}),
});

ScrollTrigger.batch(".left", {
	onEnter: batch => gsap.from(batch, {
		duration: 1, 
		x: -100,
		autoAlpha : 0,
	}),
});

ScrollTrigger.batch(".right", {
	onEnter: batch => gsap.from(batch, {
		duration: 1, 
		x: 100,
		autoAlpha : 0,
	}),
});

ScrollTrigger.batch(".bottom", {
	onEnter: batch => gsap.from(batch, {
		duration: 1, 
		y: 100,
		autoAlpha : 0,
	}),
});

ScrollTrigger.batch(".stagger", {
	onEnter: batch => gsap.from(batch, {
		duration: 1, 
		y: 100,
		autoAlpha : 0,
		stagger: .5,
	}),
});

  
});